import { Button, Paper, Stack, Text, Title } from "@repo/ui/core";
import { IconAlertTriangle, IconReload } from "@repo/ui/icons";

/** Hard-error timeout for a declared display stream to arrive (design doc D5). */
export const DISPLAY_STREAM_TIMEOUT_MS = 30_000;

/** Hard-error overlay for the display area (no video, stream timeout, TURN unreachable). */
export interface DisplayErrorOverlayProps {
  title: string;
  message: string;
  onRestart?: () => void;
  isRestarting?: boolean;
  disableRestart?: boolean;
}

export function DisplayErrorOverlay({
  title,
  message,
  onRestart,
  isRestarting,
  disableRestart,
}: DisplayErrorOverlayProps) {
  return (
    <Paper
      withBorder
      radius="md"
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "var(--mantine-color-red-light)",
        borderColor: "var(--mantine-color-red-outline)",
      }}
    >
      <Stack align="center" gap="sm" p="xl" maw={440} style={{ textAlign: "center" }}>
        <IconAlertTriangle size={36} color="var(--mantine-color-red-6)" />
        <Title order={4}>{title}</Title>
        <Text size="sm" c="dimmed">
          {message}
        </Text>
        {onRestart && (
          <Button
            color="red"
            variant="filled"
            size="xs"
            mt="xs"
            leftSection={<IconReload size={16} />}
            loading={isRestarting}
            disabled={disableRestart}
            onClick={onRestart}
          >
            Restart emulator
          </Button>
        )}
      </Stack>
    </Paper>
  );
}
